'use strict';

var states = require('./NavDrawerStates');

function NavDrawerDirective ($animate, $q, $timeout, $window, sbPositionUtil) {

  var link = function ($scope, $el, attrs, ctrl, $transclude) {
    var wrapperNode = sbPositionUtil.getParentOffsetNode($el);
    var wrapperEl = angular.element(wrapperNode);

    $el.addClass('sb-nav-drawer');

    var parentScope;

    // add transcluded elements
    $transclude(function (clone, transcludedScope) {
      $el.append(clone);
      parentScope = transcludedScope;
    });

    // initialize
    // ... open drawer if needed
    if (ctrl.open) {
      openDrawer();
    }

    function openDrawer () {
      ctrl.setState(states.opening);
      var cancelFn = whileAnimating();
      
      return $animate.addClass(wrapperEl, 'open-drawer')
      .then(function () {
        ctrl.setState(states.opened);

        cancelFn();

        if (ctrl.afterOpen) {
          ctrl.afterOpen();
        }
      });
    }

    function closeDrawer () {
      if (wrapperEl.hasClass('open-drawer')) {
        ctrl.setState(states.closing);
        var cancelFn = whileAnimating();
        
        return $animate.removeClass(wrapperEl, 'open-drawer')
        .then(function () {
          if (ctrl.state !== states.opening && ctrl.state !== states.opened ) {
            $scope.$applyAsync(function () {
              ctrl.setState(states.closed);
            });
          }

          cancelFn();

          if (ctrl.afterClose) {
            ctrl.afterClose();
          }
        });
      }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////
    // Event Handlers
    ///////////////////////////////////////////////////////////////////////////////////////////////

    var onOpenChange = function (delta) {

      var open = delta.open.current;

      if (open) {
        // Send the events before animation
        parentScope.$broadcast('sbDrawer:change', delta, true);
        openDrawer();
      } else {
        closeDrawer().then(function () {
          // Wait for the animation to send the change events
          parentScope.$broadcast('sbDrawer:change', delta, true);
        });
      }
    };

    /**
     * Used to execute the user specified whileAnimating callback every 5ms for the duration of the
     * animation
     *
     * @return {Function} interval cancel function
     */
    function whileAnimating () {
      var id;

      if (ctrl.whileAnimating) {
        id = $window.setInterval(function () {
          ctrl.whileAnimating();
        }, 5);
      }

      return function cancel () {
        if (id) {
          $window.clearInterval(id);
        }
      };
    };

    var buildChangeObject = function(currentValues, previousValues) {
      return {
        page : {
          previous : previousValues[0],
          current : currentValues[0]
        },
        view : {
          previous : previousValues[1],
          current : currentValues[1]
        },
        open : {
          previous : previousValues[2],
          current : currentValues[2]
        }
      };
    };

    var onStateChange = function(newValues, previousValues) {

      // Investigate: angular sends the change event the first time even if
      // there are not changes
      // if(newValues === previousValues) {
      //   return;
      // }

      var delta = buildChangeObject(newValues, previousValues);

      if(delta.open.current !== delta.open.previous) {
        onOpenChange(delta);
      } else {
        parentScope.$broadcast('sbDrawer:change', delta, false);
      }
    };

    // No need to debounce since the call is triggered only once at each $digest
    // lifecycle (http://teropa.info/blog/2014/01/26/the-three-watch-depths-of-angularjs.html)
    $scope.$watch(ctrl._getState, onStateChange, true);
  };

  /////////////////////////////////////////////////////////////////////////////////////////////////
  // Directive Definition Object
  /////////////////////////////////////////////////////////////////////////////////////////////////

  return {
    bindToController: true,
    controller: 'sbNavDrawerController',
    controllerAs: 'sbNavDrawerCtrl',
    link: link,
    restrict: 'EA',
    scope: {
      afterClose: '&', // callback to execute when close is completed
      afterOpen: '&', // callback to execute when open is completed
      open: '=?',
      page: '=?',
      pageView: '=?',
      whileAnimating: '&', // callback to execute while opening or closing (fires every 5ms)
    },
    transclude: true,
  };
}

NavDrawerDirective.$inject = ['$animate', '$q', '$timeout', '$window', 'sbPositionUtil'];
module.exports = NavDrawerDirective;


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/layout/src/nav/NavDrawerDirective.js